"use client";

import { useState } from "react";

export default function OKMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, logo } = league || {};

  return (
    <div className="mr-0.5 mb-4 box-border overflow-hidden rounded-xl border kbv-card last:mb-0">
      {/* card-title */}
      <div
        role="button"
        tabIndex={0}
        onClick={() => setIsExpanded((prev) => !prev)}
        className="relative box-border flex h-[3.625rem] cursor-pointer items-center justify-between border-b border-[var(--theme-border)] pb-2.5 md:pr-[30px] pl-2 md:pl-[34.5px] text-sm leading-[3.625rem] text-[var(--theme-text)] kbv-shadow-main"
        aria-expanded={isExpanded}
      >
        {/* left */}
        <div className={`flex items-center overflow-hidden ${isExpanded ? "max-w-[50%] md:max-w-[32%]" : "max-w-[calc(100%-60px)]"}`}>
          <span className="flex flex-row items-center overflow-hidden text-ellipsis whitespace-nowrap text-sm leading-4 md:text-xl md:leading-normal text-[var(--theme-text)]">
            {logo ? (
              <img
                src={logo}
                alt={name || "league"}
                className="mr-2.5 h-6 w-6 md:h-7.5 md:w-7.5 shrink-0 object-contain"
                width={30}
                height={30}
                loading="lazy"
              />
            ) : null}
            <span className="mr-2.5 overflow-hidden text-ellipsis whitespace-nowrap text-sm leading-4 md:text-xl md:leading-normal text-[var(--theme-text)]">{name}</span>
          </span>
        </div>

        {/* right - only show when collapsed */}
        <div className={`flex w-[18%] items-center justify-end ${isExpanded ? "hidden" : ""}`}>
          <p className="md:ml-2.5 flex items-center justify-between rounded-lg bg-[var(--theme-border)] px-[13px] text-sm font-semibold leading-5 text-[var(--theme-text)]">
            {matches.length}
          </p>
        </div>
      </div>

      {/* card-display */}
      {isExpanded ? (
        <div className="bg-[var(--theme-bg)] mt-1 kbv-shadow-inset">
          {matches.map((match, idx) => render(match, idx))}
        </div>
      ) : null}
    </div>
  );
}
